import styled from "styled-components";

/**
 * Screen-reader / parser only text. Stays in the accessibility tree and the static
 * HTML (unlike `display: none`), which the pricing page relies on for LLM and crawler
 * readability (see SUBSCRIPTION_FLOWS / pricing handover §5). Uses the standard
 * clip-rect pattern.
 */
export const VisuallyHidden = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;
